import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LazyLoad from 'react-lazy-load';
import ReactLoading from 'react-loading';
import './gallery.css';
import axios from 'axios';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import heic2any from 'heic2any'; 
function Gallery() {
  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [pass, setPass] = useState('');
  const [loading, setLoading] = useState(false);


  const handleImage = async () => {
    setLoading(true);
    if (pass !== '1112') {
      toast.error("Hey!, could you please ask Shyam for the password");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let convertedFile = file;
     
      if (file.name.toLowerCase().endsWith('.heic')) {
        const result = await heic2any({ blob: file, toType: 'image/jpeg' });
        convertedFile = new File([result], file.name.replace('.heic', '.jpg'), { type: 'image/jpeg' });
      }
      formData.append(`files`, convertedFile);
    }

    try {
      const res = await axios.post('https://image-portfolio.onrender.com/upload', formData);
      // const res = await axios.post('http://localhost:2000/upload', formData);
      console.log(res);
      toast.success("Images Uploaded");
      setFiles([]); 
      setPass('');
      fetchImages();
    } catch (err) {
      console.error(err);
      toast.error("Error uploading images");
    }
    setLoading(false);
  };
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15); 
  const fetchImages = () => {
    // .get('https://image-portfolio.onrender.com/getimage')
    axios
      .get(`https://image-portfolio.onrender.com/getimage?page=${page}&limit=${limit}`)
      .then((response) => {
        console.log('Images response:', response.data.data); 
        setImages(response.data.data); 
      })
      .catch((error) => {
        console.error('Error fetching images:', error); 
      });
  };

  useEffect(() => {
    fetchImages();
  }, [page, limit]);
  
  const [enlargedIndex, setEnlargedIndex] = useState(null);

  const handleImageClick = (index) => {
    setEnlargedIndex(index);
  };

  const handleCloseEnlarged = () => {
    setEnlargedIndex(null);
  };

 
  return (
    <div style={{ marginTop: '6em', marginBottom: '6rem', width: '100%' }}>
      <div className='box1'>
        <h2 style={{ textAlign: 'center' }}>Image Gallery</h2>
        <div className='textareaa' style={{ marginBottom: '4rem' }}>
          {loading ? (
            <div className='loading'>
              <ReactLoading
                type="spinningBubbles"
                color="#0000FF"
                height={100}
                width={50}
              />
            </div>
          ) : (
            <div>
              <input type="password" placeholder='Enter Password'  onChange={(e) => setPass(e.target.value)} value={pass} />
              <input type="file" multiple onChange={(e) => setFiles(e.target.files)} />
              <button onClick={handleImage}>Upload</button>
            </div>
          )}
        </div>
      </div>
      <div>
        <div className='location'>
        <button class="button-64" role="button"><span class="text">Bengaluru</span></button>
        <button class="button-64" role="button"><span class="text">Pune</span></button>
        <button class="button-64" role="button"><span class="text">Bhopal</span></button>
        <button class="button-64" role="button"><span class="text">Chennai</span></button>
        <button class="button-64" role="button"><span class="text">Ahmedabad</span></button>
        <button class="button-64" role="button"><span class="text">Ujjain</span></button>

        </div>
      </div>

  
      {images.length < 1 ? (
        <div className='loading'>
          <ReactLoading
            type="spinningBubbles"
            color="#0000FF"
            height={100}
            width={50}
          />
        </div>
      ) : (
        <div className='container' style={{ maxWidth: '1200px', margin: '0 auto' }}>
      {enlargedIndex !== null && (
        <div className='enlarged' onClick={handleCloseEnlarged}>
          <img
            src={`https://image-portfolio.onrender.com/Images/${images[enlargedIndex].image}`}
            alt={`Image ${enlargedIndex}`}
          />
        </div>
      )}
      <div className='row'>
        <div className='col-12'>
          <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 768: 3, 992: 4 }}>
            <Masonry gutter='1rem'>
              {images.map((imageItem, index) => (
                <img
                  key={index}
                  src={`https://image-portfolio.onrender.com/Images/${imageItem.image}`}
                  alt={`Image ${index}`}
                  style={{ width: '100%', display: 'block', borderRadius: '10px' }}
                  onClick={() => handleImageClick(index)}
                />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    </div>
      )}
      <ToastContainer />
      <div className='pre-next-btn'>
        <button className="previous" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</button>
        <button className="next" onClick={() => setPage(page + 1)}>Next</button>
      </div>
    </div>
  );
}

export default Gallery;